import request from '@/utils/request'

// 刷题组

let ShuatiApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.shuati/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.shuati/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.shuati/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.shuati/edit', data, errorback);
    },

    /*状态*/
    status(data, errorback) {
      return request._post('/shop/study.shuati/status', data, errorback);
  },
}

export default ShuatiApi;



// WEBPACK FOOTER //
// ./src/api/study/shuati.js